import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar-content flex flex-row" }
const _hoisted_2 = { class: "flex flex-row items-center h-full" }

import { ref, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import NavDropdown from '../global/NavDropdown.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const isNavBarHidden = ref(false);

const router = useRouter();

onMounted(() => {
  window.addEventListener('scroll', handleNavBarVisibility)
  window.addEventListener('mousemove', handleNavBarVisibility)
});
onUnmounted(() => {
  window.removeEventListener('scroll', handleNavBarVisibility)
  window.removeEventListener('mousemove', handleNavBarVisibility)
})

let visibleTimeout: ReturnType<typeof setTimeout> | null = null;

const handleNavBarVisibility = (event?: Event): void => {
  const scrollY = window.scrollY;
  const mouseY = event instanceof MouseEvent ? event.clientY : null;

  if (scrollY > 300 && (mouseY == null || mouseY > 75)) {
    if (visibleTimeout) clearTimeout(visibleTimeout); 
    visibleTimeout = setTimeout(() => {
      isNavBarHidden.value = true;
    }, 300); 
  } 
  else if (scrollY <= 300 || (mouseY !== null && mouseY <= 75)) {
    if (visibleTimeout) clearTimeout(visibleTimeout);
    visibleTimeout = setTimeout(() => {
      isNavBarHidden.value = false;
    }, 100); 
  }
};

const aboutMeOptions = {
  "My Bio": "/about-me",
  "Hobbies & Interests": "/interests"
}

const projectsOptions = {
  "All Projects": "/projects",
  "CV Climbing Hold Classifier": "/climbing-hold-classifier",
  "ArtHuddle": "/art-huddle",
  "clairgreen.com": "/my-website",
  "POVO Class Registration": "/povo-interface",
  "Turn-Based Battle Sim": "/rpg-battle-sim",
  "Eagle Project": "/eagle-project",
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["navbar fixed z-20 w-full bg-[rgba(106,153,143,.85)]", { 'slide-up': isNavBarHidden.value }]),
    "backdrop-blur-md": ""
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "site-title flex items-center h-full ml-6",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(router).push('/')), ["prevent"]))
      }, "Clair Green"),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "link text-base"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("Home")
          ])),
          _: 1
        }),
        _createVNode(NavDropdown, {
          title: 'About Me',
          options: aboutMeOptions
        }),
        _createVNode(NavDropdown, {
          title: 'My Projects',
          options: projectsOptions
        }),
        _createVNode(_component_router_link, {
          to: "/skills-experience",
          class: "link text-base"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("Skills & Experience")
          ])),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/contact",
          class: "link text-base"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode("Contact Me")
          ])),
          _: 1
        })
      ])
    ])
  ], 2))
}
}

})